import CryptoJS from "crypto-js";

export const decryptToken = (encryptedToken) => {
    const token=localStorage.getItem(encryptedToken)||""
    try {
        const bytes = CryptoJS.AES.decrypt(token, process.env.REACT_APP_CRYPTO_SECRET);
        return bytes.toString(CryptoJS.enc.Utf8); // this is the JWT token string
    } catch (error) {
        console.error("Token decryption failed", error);
        return null;
    }
};
